import { createSelector } from "reselect";
import _ from "underscore";

import getFloorsForProjectByFirebaseId from "../floor_getters/get_floors_for_project_by_firebase_id";
import getScanDatasetsByFirebaseId from "./get_scan_datasets_by_firebase_id";
import ScanDataset from "../../../models/domain/scan_dataset";
import { ByFirebaseId } from "type_aliases";

const empty: ByFirebaseId<ScanDataset> = {};

const getScanDatasetsForProjectByFirebaseId = createSelector([
  getFloorsForProjectByFirebaseId,
  getScanDatasetsByFirebaseId
], (floors, scanDatasetsByFirebaseId) => {
  return _.chain(floors)
           .pluck("firebaseScanDatasetIds")
           .flatten()
           .reduce<ByFirebaseId<ScanDataset>>((scanDatasetsSoFar, firebaseId) => {
             scanDatasetsSoFar[firebaseId] =  scanDatasetsByFirebaseId[firebaseId];
             return scanDatasetsSoFar;
           }, {})
           .value() || empty;
});

export default getScanDatasetsForProjectByFirebaseId;
